module.exports = __webpack_public_path__ + "img/avex_coaches_top@2x.0d41f859.jpg";